import angular from 'angular';
import ContactDetailComponent from './contact-detail.component';
import ContactDetailConfig from "./contact-detail.config";
import ContactService from "../contact/contact.service";

let ContactDetailModule = angular.module('app.contactDetail', [])
    .component('contactDetail', ContactDetailComponent)
    .config(ContactDetailConfig)
    .service('ContactService', ContactService);

export default ContactDetailModule ;



/** WEBPACK FOOTER **
 ** ./www/components/contact-detail/contact-detail.js
 **/